import React from 'react';
import useStyles from './printStyles';

import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import AspectRatioIcon from '@material-ui/icons/AspectRatio';
import OpenWithIcon from '@material-ui/icons/OpenWith';
import SaveIcon from '@material-ui/icons/Save';
import CloudDownload from '@material-ui/icons/CloudDownload';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';


const ToolMenu = ({ tool, pdf, setTool, anchorEl, handleClose }) => {
  const classes = useStyles();

  return (
    <Box p={1} className={classes.sideBar}>
      <IconButton
        aria-label="move"
        color={tool == 'move' ? 'primary' : 'default'}
        onClick={() => setTool(prev => prev != 'move' ? 'move' : '')}>
        <OpenWithIcon />
      </IconButton>
      <IconButton
        aria-label="text"
        color={tool == 'resize' ? 'primary' : 'default'}
        onClick={() => setTool(prev => prev != 'resize' ? 'resize' : '')}>
        <AspectRatioIcon />
      </IconButton>
      <IconButton
        aria-label="text"
        color={tool == 'save' ? 'primary' : 'default'}
        onClick={() => {
          setTool(prev => prev != 'save' ? 'save' : '');
        }}>
        <SaveIcon />
      </IconButton>
      <IconButton
        aria-label="text"
        color={tool == 5 ? 'primary' : 'default'}
        onClick={async () => {
          const link = document.createElement('a');
          link.setAttribute('href', pdf);
          link.setAttribute('target', '_blank');
          link.setAttribute('download', 'template.pdf');
          link.click();
        }}>
        <CloudDownload />
      </IconButton>

      <Menu
        id="image-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => handleClose()}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <MenuItem onClick={() => handleClose('import')}>Import</MenuItem>
        <MenuItem onClick={() => handleClose('upload')}>Upload</MenuItem>
      </Menu>
    </Box>
  );
};


export default ToolMenu;